module.exports = __webpack_public_path__ + "media/images/soar/site/bg_create-14cae7fd33948402f9a183d990193aa2.svg";